import { render, staticRenderFns } from "./opptyCard.vue?vue&type=template&id=6f6eed05&lang=pug"
import script from "./opptyCard.vue?vue&type=script&lang=js"
export * from "./opptyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports